export function initialSearchBarQuery(query) {
    return query == null ? '' : String(query)
}
